(function () {
  if (window.__MM_BOX__) return;
  window.__MM_BOX__ = true;

  var DEBUG = false;
  function log(){ if (DEBUG && window.console) console.log.apply(console, ['[MM-BOX]'].concat([].slice.call(arguments))); }

  // ---------------------------------------------------------------------------
  // Config comes from Liquid, resolved by product HANDLE at render time. Nothing
  // about the packaging products is hardcoded here.
  //
  // The option list is open-ended: today it is standard / luxury / gift wrapping,
  // but the shop owner may add or remove one. Never assume how many there are,
  // and never assume a particular key exists.
  // ---------------------------------------------------------------------------
  function readConfig(){
    var el = document.getElementById('mm-box-config');
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent);
      if (!c || !Array.isArray(c.options)) return null;
      var valid = c.options.filter(function(o){ return o && o.key && o.variantId && o.productId; });
      if (!valid.length) return null;
      c.options = valid;
      return c;
    } catch (e) {
      log('config parse failed', e);
      return null;
    }
  }

  var config = readConfig();
  var selection = null;
  var busy = false, pending = null;

  function optionFor(key){
    if (!config) return null;
    for (var i = 0; i < config.options.length; i++) {
      if (config.options[i].key === key) return config.options[i];
    }
    return null;
  }

  function defaultKey(){
    // The free option is the sane default; fall back to whatever is first.
    var free = null;
    config.options.forEach(function(o){ if (free === null && o.price === 0) free = o.key; });
    return free || config.options[0].key;
  }

  // A cart line is packaging if it belongs to ANY of the packaging products.
  // Matching on product rather than variant is deliberate: the luxury box has
  // several size variants, and a line created from an older variant must still be
  // recognised, otherwise it never gets cleaned up and the customer pays twice.
  function isPackaging(item){
    if (!config) return false;
    for (var i = 0; i < config.options.length; i++) {
      if (item.product_id === config.options[i].productId) return true;
    }
    return false;
  }

  // Box personalisation is a paid add-on that only means anything attached to the
  // keepsake box. If the customer moves to another packaging option it must go,
  // or they are billed £2 for personalising a box they no longer have.
  function personalisationLines(cart){
    if (!config || !config.personalisation) return [];
    return cart.items.filter(function(i){
      return i.variant_id === config.personalisation.variantId;
    });
  }

  function isDisabled(key){
    var el = document.querySelector('[data-mm-box][data-key="' + key + '"]');
    return !!(el && el.classList.contains('mm-box--disabled'));
  }

  function showError(msg){
    var el = document.getElementById('mm-box-error');
    if (!el) return;
    if (el.textContent !== msg) el.textContent = msg;
    el.hidden = false;
  }

  function clearError(){
    var el = document.getElementById('mm-box-error');
    if (!el) return;
    el.hidden = true;
    if (el.textContent !== '') el.textContent = '';
  }

  // Paints must be idempotent: writing to the DOM inside a MutationObserver
  // callback that watches the DOM will otherwise re-trigger itself forever.
  function paint(key){
    selection = key;
    var boxes = document.querySelectorAll('[data-mm-box]');
    for (var i = 0; i < boxes.length; i++) {
      var el = boxes[i];
      var on = el.getAttribute('data-key') === key;
      if (el.classList.contains('mm-box--selected') !== on) {
        el.classList.toggle('mm-box--selected', on);
      }
      var radio = el.querySelector('input[name="mm-box-choice"]');
      if (radio && radio.checked !== on) radio.checked = on;
    }
  }

  // ---------------------------------------------------------------------------
  // Every cart write is status-checked. The original version of this file called
  // .json() without ever looking at res.ok, so a 422 "Cannot find variant" was
  // parsed as an ordinary result and thrown away. The cart silently lost its
  // packaging line for two months before anyone worked out why.
  // ---------------------------------------------------------------------------
  function post(url, body){
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(res){
      return res.json().catch(function(){ return {}; }).then(function(data){
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || ('HTTP ' + res.status));
          err.status = res.status;
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function runWrites(writes){
    return writes.reduce(function(chain, w){ return chain.then(w); }, Promise.resolve());
  }

  function getCart(){ return fetch('/cart.js').then(function(r){ return r.json(); }); }

  function refreshCart(){
    var openDrawer = document.querySelector('cart-drawer-component dialog[open]');
    var scope = openDrawer || document;
    var comp = scope.querySelector('cart-items-component[data-section-id]')
            || document.querySelector('cart-items-component[data-section-id]');
    var sectionId = comp ? comp.getAttribute('data-section-id') : null;

    var body = { updates: {} };
    if (sectionId) { body.sections = sectionId; body.sections_url = location.pathname; }

    return post('/cart/update.js', body).then(function(cart){
      var html = sectionId && cart.sections ? cart.sections[sectionId] : null;
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var target = openDrawer || document;
        var pairs = openDrawer
          ? ['.cart-drawer__items', '.cart-drawer__summary']
          : ['.cart-page__items', '.cart-page__summary', '.cart-page__extras'];
        pairs.forEach(function(sel){
          var freshNode = doc.querySelector(sel);
          var liveNode  = target.querySelector(sel);
          if (freshNode && liveNode) liveNode.innerHTML = freshNode.innerHTML;
        });
      }
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'mm-box', data: { source: 'mm-box', itemCount: cart.item_count, sections: cart.sections || {} } }
      }));
      var fresh = readConfig();
      if (fresh) config = fresh;
      paint(selection);
    }).catch(function(e){ log('refresh failed', e); });
  }

  // Carry the box message onto the line as it is created, rather than adding the
  // line and then patching it. One write instead of two, and no window in which
  // the box exists without the message the customer already typed.
  function pendingProperties(key){
    if (key !== 'luxury') return null;
    var input = document.getElementById('mm-box-personalisation');
    if (!input || !input.value) return null;
    var props = {};
    props['Box personalisation'] = input.value;
    return props;
  }

  // ---------------------------------------------------------------------------
  // ADD FIRST, THEN REMOVE.
  //
  // The original removed the current packaging before adding the replacement, so
  // a failed add left the customer with no packaging at all and no error. Adding
  // first means a failed write can never destroy what the cart already had.
  // ---------------------------------------------------------------------------
  function reconcile(desiredKey){
    return getCart().then(function(cart){
      var nonPackaging = cart.items.filter(function(i){ return !isPackaging(i); });
      var packaging = cart.items.filter(isPackaging);

      // Nothing left to pack means no real products at all -- add-on lines on
      // their own are not an order. An oversized gift still gets outer packaging,
      // so 'no-box' items must NOT clear the packaging line; only the luxury
      // option is withheld from them, and Liquid handles that.
      var realCount = (typeof config.realCount === 'number') ? config.realCount : nonPackaging.length;
      var nothingToPack = realCount === 0;
      if (nothingToPack) {
        var doomed = packaging.concat(personalisationLines(cart));
        if (!doomed.length) return false;
        return runWrites(doomed.map(function(i){
          return function(){ return post('/cart/change.js', { id: i.key, quantity: 0 }); };
        })).then(function(){ return true; });
      }

      var wanted = optionFor(desiredKey);
      if (!wanted) return false;

      var alreadyThere = packaging.some(function(i){ return i.variant_id === wanted.variantId; });

      var body = { id: wanted.variantId, quantity: 1 };
      var props = pendingProperties(desiredKey);
      if (props) body.properties = props;

      var step = alreadyThere
        ? Promise.resolve(false)
        : post('/cart/add.js', body).then(function(){ return true; });

      return step.then(function(added){
        // Re-read: line keys shift after a write, so removals must be computed
        // against the cart as it actually is now, not as it was a moment ago.
        return getCart().then(function(freshCart){
          var keepSeen = false;
          var ops = [];
          if (desiredKey !== 'luxury') {
            personalisationLines(freshCart).forEach(function(i){
              ops.push({ key: i.key, qty: 0 });
            });
          }
          freshCart.items.filter(isPackaging).forEach(function(i){
            if (i.variant_id === wanted.variantId && !keepSeen) {
              keepSeen = true;
              if (i.quantity !== 1) ops.push({ key: i.key, qty: 1 });
            } else {
              ops.push({ key: i.key, qty: 0 });
            }
          });
          if (!ops.length) return added;
          return runWrites(ops.map(function(op){
            return function(){ return post('/cart/change.js', { id: op.key, quantity: op.qty }); };
          })).then(function(){ return true; });
        });
      });
    });
  }

  function selectionFromCart(cart){
    var found = null;
    cart.items.forEach(function(i){
      if (found) return;
      config.options.forEach(function(o){
        if (!found && i.product_id === o.productId) found = o.key;
      });
    });
    return found;
  }

  function syncSelectionFromCart(){
    return getCart().then(function(cart){
      paint(selectionFromCart(cart) || defaultKey());
    }).catch(function(){});
  }

  function request(desiredKey){
    if (busy) { pending = desiredKey; return; }
    busy = true;
    clearError();
    reconcile(desiredKey).then(function(changed){
      busy = false;
      if (pending && pending !== desiredKey) {
        var d = pending; pending = null; request(d);
      } else {
        pending = null;
        if (changed) refreshCart();
      }
    }).catch(function(e){
      busy = false;
      pending = null;
      log('reconcile failed', e);
      showError('Sorry, we could not update your packaging just now. Your cart has not been changed. Please try again, or contact us and we will sort it out.');
      // Never leave the UI claiming a choice the cart does not actually have.
      syncSelectionFromCart();
    });
  }

  function choose(key){
    if (!config || !optionFor(key)) return;
    if (isDisabled(key)) return;
    paint(key);
    request(key);
  }

  // Delegated so it survives the section re-rendering itself on every cart write.
  document.addEventListener('click', function(ev){
    var el = ev.target && ev.target.closest ? ev.target.closest('[data-mm-box]') : null;
    if (!el) return;
    var key = el.getAttribute('data-key');
    if (!key) return;
    if (el.classList.contains('mm-box--disabled')) { ev.preventDefault(); return; }
    choose(key);
  });

  document.addEventListener('change', function(ev){
    var t = ev.target;
    if (!t || t.name !== 'mm-box-choice') return;
    choose(t.value);
  });

  // Back-compat for any markup still using the old inline handler.
  window.handleBoxChange = choose;

  var rafPending = false;
  new MutationObserver(function(){
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function(){
      rafPending = false;
      var fresh = readConfig();
      if (fresh) config = fresh;
      if (selection) paint(selection);
    });
  }).observe(document.body, { childList: true, subtree: true });

  function init(){
    if (!config) { log('no config on page, selector inactive'); return; }
    getCart().then(function(cart){
      var key = selectionFromCart(cart) || defaultKey();
      // If the cart holds packaging the customer can no longer choose (an item
      // went oversized after it was added), fall back to a valid option so
      // reconcile can clear it instead of preserving a dead state.
      if (isDisabled(key)) key = defaultKey();
      paint(key);
      request(key);
    }).catch(function(e){ log('init failed', e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
